/**
 * Is the signed-in user currently VIEWING AS an agent (D2-SEC-011, #3962)?
 *
 * The ONE flag every write affordance (create / edit / delete / complete /
 * send) reads to hide itself while a super-user or manager sees the CRM as an
 * agent sees it, read only. `AuthProvider` provides it from the server's
 * `view_as` block on `/auth/me/` -- the same source the view-as banner uses --
 * so the UI can never claim a view-as the server is not serving.
 *
 * UI only: the server refuses every write while viewing-as regardless
 * (defence in depth), and a refused write is announced once by the banner.
 *
 * Its own tiny context (not a field on the auth context) so it defaults to
 * "not viewing-as" wherever no provider is mounted -- a page rendered
 * standalone, or under a test that mocks `contexts/auth`.
 */
import { createContext, useContext } from "react";

export const ViewAsContext = createContext<boolean>(false);

export function useIsViewingAs(): boolean {
  return useContext(ViewAsContext);
}
